module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraLight.828ee50f.woff2";